import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FiUsers } from "react-icons/fi";
import TileShell from "./DashboardTiles/TileShell";

const showShortNames = (name) => {
  const fullName = name?.split(" ");
  const splitName = fullName?.map((part) => part.charAt(0)).join("");
  return splitName?.slice(0, 2);
};

const SignInTrackingCard = ({ className = "" }) => {
  const navigate = useNavigate();
  const { employeeAuditData } = useSelector((state) => state.payroll);

  const handleArrowClick = () => {
    navigate("/employeetracking");
  };

  const signedIn = employeeAuditData?.data?.signedin || [];
  const notYetIn = employeeAuditData?.data?.notyetin || [];
  const total = signedIn.length + notYetIn.length;
  const percent = total === 0 ? 0 : Math.round((signedIn.length / total) * 100);
  const isEmpty = Object.keys(employeeAuditData?.data || {}).length === 0;

  const renderNames = (names) => (
    <div className="flex flex-wrap items-center gap-1.5">
      {names?.slice(0, 5)?.map((name, index) => (
        <div key={index + 1} className="group relative">
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-700">
            {showShortNames(name?.name)}
          </div>
          <span className="pointer-events-none absolute bottom-full left-1/2 z-10 mb-1 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white opacity-0 group-hover:opacity-100">
            {name?.name}
          </span>
        </div>
      ))}
      {names?.length > 5 && (
        <button
          type="button"
          onClick={handleArrowClick}
          className="text-xs font-semibold text-blue-600 hover:underline"
        >
          +{names.length - 5} more
        </button>
      )}
    </div>
  );

  return (
    <TileShell
      icon={FiUsers}
      title="Who is in?"
      actionLabel="View all"
      onAction={handleArrowClick}
      className={className}
      bodyClassName="flex flex-col"
    >
      {isEmpty ? (
        <p className="text-sm text-gray-500">{employeeAuditData?.message}</p>
      ) : (
        <>
          <div className="flex items-baseline gap-2.5">
            <span className="text-5xl font-extrabold tracking-tight text-gray-900">
              {signedIn.length}
            </span>
            <span className="text-sm font-medium text-gray-500">
              of {total} signed in
            </span>
          </div>

          <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-amber-200">
            <div
              className="h-full rounded-full bg-green-500 transition-all"
              style={{ width: `${percent}%` }}
            />
          </div>

          <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs font-medium text-gray-600">
            <span className="inline-flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full bg-green-500" />
              Signed in ({signedIn.length})
            </span>
            <span className="inline-flex items-center gap-1.5">
              <span className="h-2 w-2 rounded-full bg-amber-400" />
              Not yet in ({notYetIn.length})
            </span>
          </div>

          <div className="mt-4">{renderNames(signedIn)}</div>
        </>
      )}
    </TileShell>
  );
};

export default SignInTrackingCard;
